import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateAllergiesCompletion(
  patient: Patient | null | undefined,
) {
  const hasAllergies = patient?.medicalHistory?.hasAllergies;
  const allergies = patient?.medicalHistory?.allergies;

  const answeredFlag = hasAllergies !== undefined && hasAllergies !== null;
  const hasAny = Array.isArray(allergies) && allergies.length > 0;

  // If they answered no, count as complete (n/a for list)
  const completed = answeredFlag
    ? 1 + (hasAllergies ? (hasAny ? 1 : 0) : 1)
    : 0;
  const percent = completed / 2;
  const label = answeredFlag
    ? hasAllergies
      ? hasAny
        ? "2/2 answered"
        : "1/2 answered"
      : "2/2 answered"
    : "0/2 answered";

  return { percent, label, completed, total: 2 };
}
